import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";
import FDataTableMDP, {
  ActionType,
} from "@/components/table/FDataTableMDP";
import FCellDateMDP from "@/components/table/cell/FCellDateMDP";
import FCellBooleanMDP from "@/components/table/cell/FCellBooleanMDP";
import FSnackbar from "@/fsnackbar";

import { ScreenType } from "./FAgreementListMDP";
import FCellCopyMDP from "@/components/table/cell/FCellCopyMDP";
import FCellDateTimeMDP from "@/components/table/cell/FCellDateTimeMDP";
import FCellStatusMDP from "@/components/table/cell/FCellStatusMDP";
import FCellUrlLinkMDP, { UrlLinkActionType } from "@/components/table/cell/FCellUrlLinkMDP";

export default class FAgreementListFDataTableMDP extends FDataTableMDP {
  parent: any;
  constructor(props: { parent: any; taskRoot: any;screenType?:ScreenType }) {
    super({
      myRefName: "fAgreementListFDataTableMDP",
      title: "Agreement List",
      disabled: props.taskRoot.taskStateTerminated,
      itemKey: "ssaToken",
    });
    this.parent = props.parent;
    this.addColumn({
      label: "Token",
      dataSelectorKey: "ssaToken",
      columnCellMDP: new FCellCopyMDP({
        dataSelectorKeyToCopy: "agreementUrl",
        tooltipText: "Click here to copy the agreement link",
      }),
    })
      .addColumn({
        label: "Generated On",
        dataSelectorKey: "generatedOn",
        columnCellMDP: new FCellDateTimeMDP(),
      })
      .addColumn({
        label: "Status",
        dataSelectorKey: "status.name",
        columnCellMDP: new FCellStatusMDP({
          colorCodeData: Data.Color.AGREEMENT_STATUS,
          outlined: true,
        }),
      })
      // .addColumn({
      //   label: "Signed",
      //   dataSelectorKey: "signed",
      //   columnCellMDP: new FCellBooleanMDP({})
      // })
      .addColumn({
        label: "Signed On",
        dataSelectorKey: "signedOn",
        columnCellMDP: new FCellDateTimeMDP(),
      })
      .addColumn({
        label: "IP Address",
        dataSelectorKey: "ipAddr",
      })
      .addColumn({
        label: "Preview",
        dataSelectorKey: "previewUrl",
        columnCellMDP: new FCellUrlLinkMDP({placeholder: "Preview",urlLinkActionType: UrlLinkActionType.Btn,openInNewTab: true})
      })
      .addAction({
        label: "Generate Agreement",
        onClick: () => this.handleGenerateLink(),
        type: ActionType.ADD,
        condition: props.screenType===ScreenType.Task
      })
      .addAction({
        label: "Refresh",
        onClick: () => this.handleRefreshClick(),
        type: ActionType.REFRESH,
        noSelect: true,
      })
      .addAction({
        label: "Resend Mail",
        onClick: this.handleResendClick(),
        type: ActionType.OTHERS,
        confirmation: true,
      });
  }

  handleGenerateLink() {
      return new Promise((res) => {
        Action.ClientFile.GenerateAgreement.execute1(
          this.parent.clientFileId,
          (output) => {
            FSnackbar.success("Successfully generated the agreement");
          }
        );
        res(true);
      });
  }

  handleRefreshClick() {
      return new Promise((res) => {
        Action.ClientFile.GetAllSignAgreementList.execute1(
          this.parent.clientFileId,
          (output) => {}
        );
        this.parent.getClientFileBasicInfo();
        res(true);
      });
  }

  openAgreementLink() {
    console.log("retsksdlsfd");
    return (item: any) => {
      console.log(item);
      if (item.agreementUrl) {
        window.open(item.agreementUrl);
      }
    };
  }

  handleResendClick() {
    return (item: any) => {
      return new Promise((res) => {
        const sendAgreementInput = new Data.ClientFile.SendAgreementInput();
        sendAgreementInput.byEmail = true;
        sendAgreementInput.bySMS = false;
        sendAgreementInput.byWhatsapp = false;
        sendAgreementInput.token = item.ssaToken;
        // Action.ClientFile.SendAgreement.execute(
        //   sendAgreementInput,
        //   (output) => {
        //     FSnackbar.success("Succesfully resend the agreement");
        //     res(true);
        //   }
        // );
      });
    };
  }

  previewLinkNewTab(item: any) {
    if (item.previewUrl) {
      window.open(item.previewUrl);
    }
  }
}
